import _mutations_set from './_mutations/set.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        set: _mutations_set,
    },
}